var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.6035V35.6035L23 28.6035H32L18 17.6035Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.6035C24.9706 29.6035 29 25.5741 29 20.6035C29 15.6329 24.9706 11.6035 20 11.6035C15.0294 11.6035 11 15.6329 11 20.6035C11 25.5741 15.0294 29.6035 20 29.6035Z",
    fill: "white",
    fillOpacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 5.60352V7.60352",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 7.61353L26.5 9.34553M32.99 13.1035L31.258 14.1035M35 20.6035H33M8.742 27.1035L7.01 28.1035M7 20.6035H5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.74177 14.1035L7.00977 13.1035M13.4998 9.34553L12.4998 7.61353",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery-icon.fd908b5af6f71e03d63f84f77fd1302c.svg";
export { ForwardRef as ReactComponent };